import React, { Fragment } from 'react'
import { isEmpty } from 'util/arrays'
import { Button } from 'util/ui'
import EmptyMessage from '../shared/EmptyMessage'
import Section from '../shared/Section'
import ChargeList from './ChargeList'
import SubscriptionList from './SubscriptionList'

const StripeView = ({ customerPageUrl, subscriptionUrls, data }) => {
  const { subscriptions, charges, customerId } = data
  return (
    <Fragment>
      {!customerId && (
        <EmptyMessage>There is no customer information</EmptyMessage>
      )}
      {subscriptions && (
        <Section label="Subscription info">
          {isEmpty(subscriptions.data) && (
            <EmptyMessage>This customer has no subscriptions</EmptyMessage>
          )}
          {subscriptions.data && (
            <SubscriptionList
              subscriptions={subscriptions.data}
              subscriptionUrls={subscriptionUrls}
            />
          )}
          {subscriptions.hasMore && (
            <Button
              as="a"
              href={customerPageUrl}
              target="_blank"
              size="small"
              primary
            >
              View all subscriptions in Stripe
            </Button>
          )}
        </Section>
      )}
      {charges && (
        <Section label="Recent charges">
          {isEmpty(charges.data) && (
            <EmptyMessage>No charges data to show here</EmptyMessage>
          )}
          {charges.data && <ChargeList charges={charges.data} />}
          {charges.hasMore && (
            <Button
              as="a"
              href={customerPageUrl}
              target="_blank"
              size="small"
              primary
            >
              View all transactions in Stripe
            </Button>
          )}
        </Section>
      )}
    </Fragment>
  )
}

export default StripeView
